import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useEffect, useRef, useState } from "react";
import { RiArrowRightSFill } from "react-icons/ri";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

type Props = {
  id: string;
  editor?: any;
  config?: any;
  data?: string;
  isError?: boolean;
  isWarning?: boolean;
  disabled?: boolean;
  onInit?: (editor: any, initialHeight?: number) => void;
  onChange: (event: any, editor: any) => void;
  onBlur?: (event: any, editor: any) => void;
  onFocus?: (event: any, editor: any) => void;
  tooltip?: {text: string, placement?: Placement};
  initialHeightvalue?: number;
  className?: string;
  widthRange?:{min: number, max: number, intialWidth: number};
  enabledWidthChange?: boolean;
  widthChangeAction?: () => void;
  onReady?:(editor: any) => void;
};

export type CkEditorHandler = {
}

// TODO: Update Default _onInit and _config to use the above props
const _onInit = (editor: any, initialHeight?: number) => {
  editor.editing.view.change((writer: any) => {
    writer.setStyle("height", initialHeight? `${initialHeight}px` :'200px', editor.editing.view.document.getRoot());
  });
};

const _config = {
  toolbar: [
    "heading",
    "|",
    "bold",
    "italic",
    "link",
    "bulletedList",
    "numberedList",
    "|",
    "outdent",
    "indent",
    "|",
    "blockQuote",
    "|",
    "undo",
    "redo",
  ],  
};

const Editor = React.forwardRef<CkEditorHandler, Props>((props, ref) => {
  const {
    id,
    editor = ClassicEditor,
    config = _config,
    data,
    disabled,
    onInit = _onInit,
    onChange,
    onBlur,
    onFocus,
    isError,
    isWarning,
    tooltip,
    initialHeightvalue,
    className,
    widthRange,
    enabledWidthChange,
    widthChangeAction,
    onReady,
  } = props;

  const [isResizing, setIsResizing] = useState(false);
  const [initialSize, setInitialSize] = useState({x: 0, y: 0});
  const [editorHeight, setEditorHeight] = useState(initialHeightvalue || 200);
  const editorRef = useRef<any>(null);
  const [editorWidth, setEditorWidth] = useState(0);
  const resizeHandleRef = useRef<HTMLDivElement | null>(null);

  const handleMouseDown = (e: MouseEvent) => {
    setIsResizing(true);
    setInitialSize({x : e.pageX, y : e.pageY});
    document.removeEventListener('mousedown', handleMouseDown)
  };

  const handleMouseUp = () => {
    setIsResizing(false);
    enabledWidthChange && widthChangeAction && widthChangeAction();
    document.removeEventListener('mousedown', handleMouseDown);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!isResizing) return;
    const resizeHandle = document.getElementById('resize');
    if (resizeHandle !== null) {
      const newHeight = -initialSize.y + e.pageY + editorHeight;
      const newWidth = -initialSize.x + e.pageX + editorWidth;
      let iniValue = initialHeightvalue? initialHeightvalue: 200;
      if (newHeight > iniValue) {
        setEditorHeight(newHeight)
        if (editorRef.current != null) {
          editorRef.current.editing.view.change((writer: any) => {
            writer.setStyle("height", newHeight + "px", editorRef.current.editing.view.document.getRoot());
          });
        }
      }
      if (widthRange && enabledWidthChange && newWidth > widthRange.min && widthRange.max > newWidth) {
        setEditorWidth(newWidth)
      }
      else if (!widthRange && enabledWidthChange && newWidth > 400) {
        setEditorWidth(newWidth)
      }
    }
  };

  useEffect(() => {
    if (isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener('mousedown', handleMouseDown)
    }

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [initialSize, isResizing]);
  
  return (
    <div style={{width : editorWidth !==0 ?`${editorWidth}px`: '100%'}}>
    <OverlayTrigger overlay={tooltip?.text ?<Tooltip id="tooltip-disabled">{tooltip?.text}</Tooltip> : <></>} placement={tooltip?.placement ? tooltip.placement: "auto"}>
    <div className={`${isError ? "ck-editor-border-err" : isWarning? "ck-editor-border-warning": ""} ${className}`}>
      <CKEditor
        disabled={disabled}
        id={id}
        editor={editor}
        config={config}
        ref={ref}
        data={data || ""}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onReady={(editor: any)=>{
          onReady && onReady(editor);
          onInit(editor, initialHeightvalue);
          let element = editor?.editing?.view?.getDomRoot()?.getBoundingClientRect();
          if (element && enabledWidthChange)
            setEditorWidth(element.width)
          editorRef.current = editor;
        }}
      />
       <div
       ref={resizeHandleRef}
        id="resize"
        className="ck-editor-footer"
        onMouseDown={()=>document.addEventListener('mousedown', handleMouseDown)}
      ><RiArrowRightSFill className="ck-editor-exapnd" style={{fontSize:"23px"}}/>
      </div>
    </div>
    </OverlayTrigger>
    </div>
  );
})
export default Editor;
